import React, { useMemo } from "react";
import PT from "prop-types";
import * as S from "./styled";
import Tooltip from "_c/Tooltip";
import CarIcon from "_c/icon/Car";
import HomeIcon from "_c/icon/Home";
import BuildingIcon from "_c/icon/Building";
import GlobeIcon from "_c/icon/Globe";
import isempty from "lodash/isEmpty";
import { LinkGenerator } from "@/utils/LinkGenerator";
import qs from "query-string";

const ns = "common:master_badges";

export const getBannedTerms = (master) => {
  return [
    !master.work_with_child && "ban_children",
    !master.work_with_man && "ban_men",
    !master.work_with_woman && "ban_women",
  ].filter(Boolean);
};
const AttentionSign = ({ master, t }) => {
  const terms = useMemo(() => {
    const banned = getBannedTerms(master);
    if (isempty(banned)) return null;
    return banned.map((term) => t(`${ns}.${term}`)).join(", ");
  }, [master, t]);
  if (!terms) {
    return null;
  }
  return (
    <Tooltip title={t(`${ns}:ban_list`, { terms })}>
      <S.Badge negative>
        <S.AttentionSign>!</S.AttentionSign>
      </S.Badge>
    </Tooltip>
  );
};
const MasterBadges = ({ master, hl, className, t }) => {
  const { saloon, saloon_meta, owned_saloon } = master;
  const saloonId =
    saloon_meta?._id || saloon?._id || saloon || owned_saloon?._id;
  const saloonProfile = saloonId && LinkGenerator.saloonProfile(saloonId);
  const saloonTitle = saloon_meta?.title || owned_saloon?.title;
  const saloonLoc = saloon_meta?.location_hr || owned_saloon?.location_hr;
  return (
    <S.Wrap className={className}>
      <AttentionSign t={t} master={master} />
      {master.the_road && (
        <Tooltip title={t(`${ns}.road`, { radius: master.the_road_radius })}>
          <S.Badge greenish>
            <CarIcon color="white" />
          </S.Badge>
        </Tooltip>
      )}
      {master.at_home && (
        <Tooltip title={t(`${ns}.home`)}>
          <S.Badge greenish>
            <HomeIcon color="white" />
          </S.Badge>
        </Tooltip>
      )}
      {master.works_online && (
        <Tooltip title={t(`${ns}.online`)}>
          <S.Badge greenish>
            <GlobeIcon width="20" color="white" />
          </S.Badge>
        </Tooltip>
      )}
      {saloonId && (
        <Tooltip
          title={
            saloonLoc
              ? t(`${ns}.saloon_with_address`, {
                  title: saloonTitle,
                  address: saloonLoc,
                })
              : t(`${ns}.saloon`, { title: saloonTitle })
          }
        >
          <S.SaloonBadge
            greenish
            to={
              hl
                ? qs.stringifyUrl({
                    url: saloonProfile,
                    query: { hl },
                  })
                : saloonProfile
            }
          >
            <BuildingIcon color="white" />
          </S.SaloonBadge>
        </Tooltip>
      )}
    </S.Wrap>
  );
};
MasterBadges.propTypes = {
  master: PT.object,
  className: PT.string,
  hl: PT.string,

  t: PT.func.isRequired,
};

export default MasterBadges;
